import { Component, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { CollegeService, testdetails } from '../services/College_name.service';
import * as moment from 'moment';
import { PageEvent } from '@angular/material';
import { Router } from '@angular/router';


@Component({
  selector: 'app-test-evaluation',
  templateUrl: './test-evaluation.component.html',
  styleUrls: ['./test-evaluation.component.scss']
})
export class TestEvaluationComponent implements OnInit {

  Testdetails : testdetails = {collegeid:'',yearid:'',setid:'',startdate:''};
  
  CollegeId: string;
  YearId: string;
  SetId: string;
  startDate: Date;
  endDate: Date;
  yearid: string;
  qsid: string;
  startdate: string;
  CollegeIdFromDb: any [] = [];
  StartDateFromDb: any [] = [];
  isCustomStyleApplied: boolean = false;
  CollegeNameFromDb: any;
  StartDatesFromDb: any [] = [];
  ScheduleDetailsFromDb: any[] = [];
  timeArray: any [] = [];
  // currentPage: number = 1;
  // cardsPerPage: number = 4;
  // currentPageEval: number = 1;
  // cardsPerPageEval: number = 3;
  evaluationDropDownFields:string [] = ['All','Pending','Evaluated'];
  dateArray:Date [] = [];
  selectedFieldEqualsAll: boolean = true;
  selectedFieldEqualsPending: boolean = false;
  selectedFieldEqualsEvaluated: boolean = false;
  filteredRecords: any[] = [];
  newArray: any[] = [];
  ScheduleDetailsFromDbFiltered: any[] = [];
  newFilteredArray: any[] = [];
  newDateArray: any[] = [];
  newSecondArray: any[] = [];
  OutputArray: any[] = [];
  OutputArrayNew: any[] = [];
  defaultScreen: boolean = true;
  dateFilteredScreenForLastFourteenDays: boolean = false;
  // OutputArrayNew: any[] = [];
  OutputArraylastFiltered: any[] = [];
  dateFilteredScreen: boolean = false;
  itemsPerPage = 9;
  currentPage = 1;
  paginatedData: any[] = [];
  screenWidth: number | undefined;
  screenHeight: number | undefined;
  totalPages: number;
  pagedCards: any[];
  pageSize = 9;
  pageSizeOptions: number[] = [3, 6,9];
  pendingRecordsArray: any [] = [];
  completedRecordsArray: any [] = [];
  newPendingRecordsArray: any[] = [];
  newCompletedRecordsArray: any[] = [];
  lname: string;
  fname: string;
  user: string;
  userAdmin: boolean;
  userEvaluator: boolean;
  userTestScheduler: boolean;
  last14pagedCards: any[];
  selectedOption: any='All';
  selectedOptionInDb: string;
  constructor(private fs: CollegeService,private cdr: ChangeDetectorRef,private router: Router) { }

  ngOnInit() {
    this.displayCardDetails();
    //this.onlyDisplayLast14DaysRecords();
    this.updatePaginatedData();
    this.getAccess();
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
    
  }
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
    
    this.screenHeight = window.innerHeight;
   
  }
 
applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
     
      if (this.screenWidth < 1366 && this.screenHeight <  641) {
        this.isCustomStyleApplied = true;
       
      }
    }
  }
  getAccess(){
    console.log("Inside the get Access func of test evaluation");
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');

    console.log("FNAME ,LNAME",this.fname,this.lname)
    console.log("USER ID ",this.user);

    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      console.log("CONDITION PASSED");
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  updatePage(pageIndex: number, pageSize: number,arr:any[]) {
    console.log("inside update Page",this.ScheduleDetailsFromDb)
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;
    this.pagedCards = arr.slice(startIndex, endIndex);
    console.log("pagedCards",this.pagedCards)
  }

  onPageChange(event: PageEvent,arr:any[]) {
    console.log("Entered on PageChange");
    const { pageIndex, pageSize } = event;
    this.updatePage(pageIndex, pageSize,arr);
  }




  getMaxDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  onlyDisplayLast14DaysRecords(inputArray){
    // this.dateFilteredScreen= true;
   // this.defaultScreen = false;
   // this.dateFilteredScreen = false;
    this.OutputArrayNew = [];
    this.endDate = new Date();
    this.startDate = new Date();
    this.startDate.setDate(this.endDate.getDate() - 14);
    console.log("startdate",this.startDate);
    console.log("enddate",this.endDate);


    var startDateFormatted = moment(this.startDate).format('YYYY/MM/DD');
    var endDateFormatted = moment(this.endDate).format('YYYY/MM/DD');

    

    console.log("09",startDateFormatted);
    console.log("08",endDateFormatted);
    console.log("45",typeof(startDateFormatted));

    console.log("Schedule details",inputArray);

    for(var i=0;i<inputArray.length;i++){
      this.OutputArraylastFiltered[i] = inputArray[i];
    }

    console.log("OP ARRr",this.OutputArraylastFiltered);

    for(var i=0;i<this.OutputArraylastFiltered.length;i++){

      //moment(this.ScheduleDetailsFromDb[i].Start_Date).format('YYYY-MM-DD');
      if(this.OutputArraylastFiltered[i].Start_Date >= startDateFormatted && this.OutputArraylastFiltered[i].Start_Date <= endDateFormatted){
        console.log("45678",this.OutputArraylastFiltered[i].Start_Date);
       // moment(this.ScheduleDetailsFromDb[i].Start_Date).format('DD/MM/YYYY');
        this.OutputArrayNew.push(this.OutputArraylastFiltered[i]);
      }
      //moment(this.ScheduleDetailsFromDb[i].Start_Date).format('DD/MM/YYYY');
    }


   


    console.log("Printing the op array New" ,this.OutputArrayNew);

this.last14pagedCards = [];
this.last14pagedCards = this.OutputArrayNew;
this.updatePage(0, this.pageSize,this.last14pagedCards);
  //  return this.OutputArrayNew;
  return this.last14pagedCards;


  }



  displayCardDetails(){

    var moment = require('moment');


    this.fs.get_schedule_details().subscribe(
      (data) => {

        console.log("DATA RESPONSE ",data.results);

        this.ScheduleDetailsFromDb = data.results;

      
        console.log("Obatined College Ids From the Data base",this.CollegeIdFromDb);
        console.log("Printing schedule details from db ",this.ScheduleDetailsFromDb);
        for(var i=0;i<this.ScheduleDetailsFromDb.length;i++){
          //console.log("Inside the loop 10");
          this.checkSessiondetails(this.ScheduleDetailsFromDb[i].Start_Time);
          var trimmeddate = this.ScheduleDetailsFromDb[i].Start_Date; 
          var newDate = moment(trimmeddate).format('YYYY/MM/DD')
         // console.log("Printing the trimmed date ",newDate);
          this.ScheduleDetailsFromDb[i].Start_Date = newDate;
          //this.trimStartDate(this.ScheduleDetailsFromDb[i].Start_Date);
        
          
        }


       console.log("Printing the final array ",this.ScheduleDetailsFromDb);
       this.onlyDisplayLast14DaysRecords(this.ScheduleDetailsFromDb);

       this.totalPages = this.getTotalPages();
        
  
      },
      err => {
        console.error(err);
      }
    );


  }





  checkSessiondetails(time){
   // console.log("Printing the input time ",time);
    const hours = time.slice(0,2);
   // console.log("Hour Printing ",hours);
    if(hours > 11){
      return 'AN';
    }else{
      return 'FN';
    }
  }

  openEvaluatorBench(record){
    console.log("rec",record)
    const params = { Question_Set_Id: record.Question_Set_Id,College_Id:record.College_Id,Year_Id:record.Year_Id,College_Name:record.College_Name,isEvaluated:record.Is_Evaluated };
    console.log("params",params)
    this.router.navigate(['/evaluator_workbench',params])

  }





  getRecordsWithinDate() {
    // this.defaultScreen = false;
    //this.dateFilteredScreenForLastFourteenDays= false;
    // this.dateFilteredScreen = true;
    this.OutputArrayNew = [];
    const startDate = this.startDate;
    const endDate = this.endDate;

    console.log("1",startDate);
    console.log("2",endDate);
    
   
    var startDateFormatted = moment(startDate).format('YYYY/MM/DD');
    var endDateFormatted = moment(endDate).format('YYYY/MM/DD');

    

    console.log("09",startDateFormatted);
    console.log("08",endDateFormatted);
    console.log("45",typeof(startDateFormatted));


    for(var i=0;i<this.ScheduleDetailsFromDb.length;i++){
      this.OutputArray[i] = this.ScheduleDetailsFromDb[i];
    }

    console.log("OP ARRr",this.OutputArray);

    for(var i=0;i<this.OutputArray.length;i++){

      //moment(this.ScheduleDetailsFromDb[i].Start_Date).format('YYYY-MM-DD');
      if(this.selectedOption == "All"){
        if(this.OutputArray[i].Start_Date >= startDateFormatted && this.OutputArray[i].Start_Date <= endDateFormatted){

          console.log("45678",this.OutputArray[i].Start_Date);
         // moment(this.ScheduleDetailsFromDb[i].Start_Date).format('DD/MM/YYYY');
          this.OutputArrayNew.push(this.OutputArray[i]);
        }
      }
      else{

        if(this.selectedOption == "Pending"){
          this.selectedOptionInDb = "Pending";
        }else if(this.selectedOption == "Evaluated"){
          this.selectedOptionInDb = "Completed";
        }

      if(this.OutputArray[i].Start_Date >= startDateFormatted && this.OutputArray[i].Start_Date <= endDateFormatted && this.OutputArray[i].Is_Evaluated == this.selectedOptionInDb ){

        console.log("45678",this.OutputArray[i].Start_Date);
       // moment(this.ScheduleDetailsFromDb[i].Start_Date).format('DD/MM/YYYY');
        this.OutputArrayNew.push(this.OutputArray[i]);
      }
    }
      //moment(this.ScheduleDetailsFromDb[i].Start_Date).format('DD/MM/YYYY');
    }


   


    console.log("Printing the op array New" ,this.OutputArrayNew);

    this.pagedCards = [];
    // this.pagedCards.push(this.OutputArrayNew);



    this.pagedCards = this.OutputArrayNew;

    console.log("Printing the paged cards inside the func",this.pagedCards);
    this.updatePage(0, this.pageSize,this.pagedCards);
    


    //this.cdr.detectChanges();
    
    return this.pagedCards;

  }
  
  





  showEvaluatedStatus(selectedField){
    this.selectedOption = selectedField;
    if(selectedField == 'All'){
      console.log("Printing the Output Records All",this.OutputArrayNew);
      this.updatePage(0, this.pageSize,this.OutputArrayNew);
      this.selectedFieldEqualsAll = true;
      this.selectedFieldEqualsPending = false;
      this.selectedFieldEqualsEvaluated = false;
    }else if(selectedField == 'Pending'){
      console.log("Printing the Output Records Pending",this.OutputArrayNew);
      for(var i=0;i<this.OutputArrayNew.length;i++){
        if(this.OutputArrayNew[i].Is_Evaluated == 'Pending'){
          this.pendingRecordsArray.push(this.OutputArrayNew[i]);
        }
      }

      this.newPendingRecordsArray = this.pendingRecordsArray;

      console.log("Printing new Pending Record ",)

      console.log("Pending Array printing ",this.pendingRecordsArray);
      this.updatePage(0, this.pageSize,this.pendingRecordsArray);
      this.pendingRecordsArray = [];
      this.selectedFieldEqualsPending = true;
      this.selectedFieldEqualsAll = false;
      this.selectedFieldEqualsEvaluated = false;
    }else if(selectedField == 'Evaluated'){
      console.log("Printing the Output Records Evaluated",this.OutputArrayNew);
      for(var i=0;i<this.OutputArrayNew.length;i++){
        if(this.OutputArrayNew[i].Is_Evaluated == 'Completed'){
          this.completedRecordsArray.push(this.OutputArrayNew[i]);
        }
      }

      this.newCompletedRecordsArray = this.completedRecordsArray;
      console.log("Completed Array printing ",this.completedRecordsArray);
      this.updatePage(0, this.pageSize,this.completedRecordsArray);
      this.completedRecordsArray = [];

      this.selectedFieldEqualsEvaluated = true;
      this.selectedFieldEqualsAll = false;
      this.selectedFieldEqualsPending = false;
    }

  }





  // Correct
getTotalPages() {
  console.log("Inside the get Total pages func");
  return Math.ceil(this.ScheduleDetailsFromDb.length / this.itemsPerPage);
}

// get paginatedData(): any[] {
//   console.log("Inside the get paginated data func");
//   const startIndex = (this.currentPage - 1) * this.itemsPerPage;
//   const endIndex = startIndex + this.itemsPerPage;
//   return this.ScheduleDetailsFromDb.slice(startIndex, endIndex);
// }

// previousPage() {
//   console.log("prev page func");
//   this.currentPage--;
// }

// nextPage() {
// console.log("next page func");
//   this.currentPage++;
// }


updatePaginatedData() {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.paginatedData = this.ScheduleDetailsFromDb.slice(startIndex, endIndex);
  console.log(" 4444 Printing the Paginated data ",this.paginatedData);
 // return this.paginatedData;
}
previousPage() {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

nextPage() {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}


  
  

}
